import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';

export const summaryMixin = {
	watch: {
		currentStep() {
			if (this.isSummaryEnabled && this.isLastStep) {
				this.createModelForSummary();
			}
		}
	},
	methods: {
		getLabelOfInput(inputId) {
			return this.labelsOfInputs ? this.labelsOfInputs[inputId] : '';
		},
		createModelForSummary() {
			// We can't use File objects in v-for but we can use the plain objects from uploadedFiles
			const clonedModel = cloneDeep(this.model);
			this.modelForSummary = merge({}, clonedModel, this.uploadedFiles);
		},
		editStepData(step) {
			this.changeStep(step);
		}
	}
};



// WEBPACK FOOTER //
// ../source/modules/DNFORM/DNFORM-mixins/DNFORM-summary-mixin.js